import { render } from "./ClassificacaoView.vue?vue&type=template&id=1629385c&scoped=true"
import script from "./ClassificacaoView.vue?vue&type=script&lang=js"
export * from "./ClassificacaoView.vue?vue&type=script&lang=js"

import "./ClassificacaoView.vue?vue&type=style&index=0&id=1629385c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1629385c"]])

export default __exports__